<template>
  <el-drawer :visible.sync="visible" title="问卷外观" size="80%" @close="onClose" @closed="onClosed">
    <el-container class="h-full survey-appearance" v-loading="!isLoad">
      <el-aside class="h-full p-6" width="290px">
        <el-button-group class="flex">
          <el-button class="flex-1" :type="isPC ? 'primary' : 'default'" @click="isPC = true">电脑</el-button>
          <el-button class="flex-1" :type="!isPC ? 'primary' : 'default'" @click="isPC = false">手机</el-button>
        </el-button-group>
        <div class="mt-6" v-if="isLoad">
          <template v-if="isPC">
            <pc-cover :data="otherSetting.background" @change="onChangePcCover" />
          </template>
          <template v-else>
            <h5-cover :data="otherSetting.cover" @change="onChangeH5Cover('cover')" />
            <div class="mt-3">
              <ul>
                <li>
                  <span>隐藏标题及开始语</span>
                  <el-switch
                    v-model="otherSetting.enableHideTitleWelcome"
                    @change="onChangeOtherSetting('enableHideTitleWelcome')"
                  />
                </li>
                <li>
                  <span
                    >显示参与人数
                    <el-tooltip content="参与人数统计的是问卷答题页被打开次数，非问卷提交数">
                      <span class="text-icon-default">
                        <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                      </span>
                    </el-tooltip>
                  </span>
                  <el-switch v-model="otherSetting.enableAnswerCount" @change="onChangeOtherSetting('enableAnswerCount')" />
                </li>
              </ul>
            </div>
            <AnswerEndCover class="mt-3" :data="otherSetting.answerEndBackground" @change="onChangeH5Cover('answerEndBackground')"/>
          </template>
          <div class="split-line mb-4 mt-3"></div>
          <button-option :data="otherSetting.buttonOption" @change="onChangeButton" />
        </div>
      </el-aside>
      <el-main class="h-full bg-bg-common-color">
        <div :class="{ mobile: !isPC }" class="h-full">
          <div :class="[isPC ? 'h-full' : 'model-container h-full']">
            <iframe id="wgContent" ref="sonEl" :src="iframeUrl" frameborder="0" width="100%" height="100%"></iframe>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import PcCover from '@/views/survey/edit/aside/appearance/PcCover'
import H5Cover from '@/views/survey/edit/aside/appearance/H5Cover'
import { surveyInfo } from '@/api/wenjuan/wjquestion'
import GlobalConfig from '@/global/config'
import { saveSurveySetting } from '@/api/wenjuan/publish'
import { getSurveyById } from '@/api/survey'
import ButtonOption from '@/views/survey/edit/aside/appearance/ButtonOption'
import AnswerEndCover from './AnswerEndCover.vue'

export default {
  name: 'AppearanceDrawer',
  components: { ButtonOption, H5Cover, PcCover,AnswerEndCover },
  props: {
    initActiveTab: {
      type: String,
      default: 'pc'
    }
  },
  data() {
    return {
      visible: true,
      isPC: true,
      isLoad: false,
      otherSetting: {},
      versionId: ''
    }
  },
  computed: {
    iframeUrl() {
      let name = this.isPC ? 'pc' : 'mobile'
      return `${
        window.location.origin
      }/${name}/index.html?surveyId=${GlobalConfig.getSurveyId()}&companyid=${GlobalConfig.getCompanyId()}&isTest=true${
        this.isPC ? '' : '&isPhone=true'
      }${this.versionId ? '&versionId=' + this.versionId : ''}`
    }
  },
  created() {
    this.init()
  },
  methods: {
    onChangePcCover() {
      saveSurveySetting({
        id: GlobalConfig.getSurveyId(),
        otherSetting: {
          background: this.otherSetting.background
        }
      }).then(() => {
        this.changeTheme({
          background: this.otherSetting.background
        })
      })
    },
    onChangeH5Cover(key) {
      saveSurveySetting({
        id: GlobalConfig.getSurveyId(),
        otherSetting: {
          [key]: this.otherSetting[key]
        }
      }).then(() => {
        this.changeTheme({
          [key]: this.otherSetting[key]
        })
      })
    },
    onChangeButton() {
      saveSurveySetting({
        id: GlobalConfig.getSurveyId(),
        otherSetting: {
          buttonOption: this.otherSetting.buttonOption
        }
      }).then(() => {
        this.changeTheme({
          buttonOption: this.otherSetting.buttonOption
        })
      })
    },
    onChangeOtherSetting(key) {
      saveSurveySetting({
        id: GlobalConfig.getSurveyId(),
        otherSetting: {
          [key]: this.otherSetting[key]
        }
      }).then(() => {
        this.changeTheme({
          [key]: this.otherSetting[key]
        })
      })
    },
    onClose() {
      this.$emit('before-close')
    },
    onClosed() {
      this.$emit('close')
    },
    changeTheme(payload) {
      const message = {
        message: 'CHANGE_THEME',
        payload
      }
      this.$refs.sonEl.contentWindow.postMessage(JSON.stringify(message), '*')
    },
    init() {
      this.isPC = this.initActiveTab === 'pc'
      getSurveyById(GlobalConfig.getSurveyId()).then(res => {
        this.versionId = res.data.data.versionId
        console.log(this.versionId)
        surveyInfo(GlobalConfig.getSurveyId()).then(res => {
          const otherSetting = res.data.data.otherSetting || {}
          this.otherSetting = Object.assign(
            {},
            {
              background: {
                image: '',
                position: 'center'
              },
              answerEndBackground: {
                image: '',
                position: 'center'
              },
              themeHeader: {
                show: false,
                image: ''
              },
              cover: {
                title: {
                  size: '18px',
                  show: '',
                  color: '#000000'
                },
                startBtn: {
                  bgColor: '#1989fa',
                  textColor: '#FFFFFF',
                  text: '开始答题'
                },
                image: ''
              },
              buttonOption: Object.assign(
                {},
                {
                  startText: '开始答题',
                  nextText: '下一页',
                  prevText: '上一页',
                  submitText: '提交',
                  bgImage: ''
                },
                otherSetting.buttonOption || {}
              ),
              enableHideTitleWelcome: false,
              enableAnswerCount: false
            },
            otherSetting
          )
          this.isLoad = true
        })
      })
    }
  }
}
</script>
